// The form's barge-in fields as the jsonb voxi-2-0 reads (assistants.barge_in_configuration).
// A field left empty is left out, so the server's own default applies; the server also ignores a
// value it cannot use, so this only drops what is plainly empty or not a number.
interface BargeInForm {
  barge_in_enabled?: boolean;
  barge_in_provider?: string;
  barge_in_model?: string;
  barge_in_threshold?: string;
  barge_in_timeout_ms?: string;
}

export function buildBargeInConfiguration(form: BargeInForm): Record<string, unknown> {
  const out: Record<string, unknown> = {
    enabled: form.barge_in_enabled !== false,
  };
  const provider = (form.barge_in_provider ?? "").trim();
  if (provider) out.provider = provider;
  const model = (form.barge_in_model ?? "").trim();
  if (model) out.model = model;
  const threshold = Number(form.barge_in_threshold);
  if ((form.barge_in_threshold ?? "").trim() !== "" && Number.isFinite(threshold)) out.threshold = threshold;
  const timeoutMs = Number(form.barge_in_timeout_ms);
  if ((form.barge_in_timeout_ms ?? "").trim() !== "" && Number.isFinite(timeoutMs)) out.timeoutMs = timeoutMs;
  return out;
}
